import React from "react";

const Computing = () => (
  <div className="computing">
    <h1>Computer tips and tricks</h1>
    <p></p>

    <p>
      <a href="https://amkhlv.github.io/bystrotex-manual/">BystroTeX</a> --- my
      method to insert LaTeX formulas into HTML
    </p>

    <p>
      <a href="https://github.com/amkhlv/mathpump3/blob/master/docs/inkscape.md">
        Notes on how to use Inkscape
      </a>{" "}
      (not entirely trivial!)
    </p>
  </div>
);

export default Computing;
